import { InventoryItem } from '@components/arsenal/inventory/InventoryItem';
import { ArsenalHeader } from '@components/arsenal/ArsenalHeader';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';

export function ArsenalInventory() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Inventory' });
  const { t: tItems } = useTranslation(undefined, { keyPrefix: 'Items' });
  const { userData } = useAppStore();

  const items = userData.items.sort((a, b) => {
    return tItems(`Items.${a.key}`).localeCompare(tItems(`Items.${b.key}`));
  });

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <ArsenalHeader description={t('description')} bg="inventory.avif" title={t('title')} />

      <div className="flex-1 overflow-y-auto">
        <div className="grid grid-cols-2 lg:grid-cols-3">
          {items.map((item, index) => (
            <InventoryItem amount={item.amount} name={item.key} key={item.key} index={index} />
          ))}
        </div>

        {items.length === 0 && (
          <div className="text-center text-sm text-gray-300 p-4">
            {t('empty')}
          </div>
        )}
      </div>
    </div>
  );
}